export const SOME_MUTATION = 'SOME_MUTATION'
